// extracted by mini-css-extract-plugin
module.exports = {"Card":"ServicesGrid_Card__aOibf","Icon":"ServicesGrid_Icon__3VxBI","ServiceLink":"ServicesGrid_ServiceLink__32gYQ"};